var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import constants from './constants';

var TOOLTIP_BASE = {
    followTouchMove: false,
    snap: 0,
    useHTML: true,
    style: {
        pointerEvents: 'auto'
    },
    fontSize: '20px'
};

var GAUGECHART_TOOLTIP_OPTIONS = {
    enabled: true,
    followPointer: true
};

var BULLET_TOOLTIP_BASE = {
    enabled: true
};

var configureTooltip = function configureTooltip(widgetConfig, customConfig) {

    var config = cloneDeep(TOOLTIP_BASE);
    var ChartConfig = widgetConfig.ChartConfig,
        BubbleChartConfig = widgetConfig.BubbleChartConfig,
        HistogramConfig = widgetConfig.HistogramConfig,
        GaugeConfig = widgetConfig.GaugeConfig,
        FlowConfig = widgetConfig.FlowConfig,
        HeatmapConfig = widgetConfig.HeatmapConfig,
        TreemapConfig = widgetConfig.TreemapConfig,
        XRangeConfig = widgetConfig.XRangeConfig;


    if (GaugeConfig) return cloneDeep(GAUGECHART_TOOLTIP_OPTIONS);
    if (ChartConfig && (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID || ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL)) return config;
    if (HistogramConfig || BubbleChartConfig || FlowConfig || TreemapConfig) return config;

    if (widgetConfig.Type.toLowerCase() === constants.chartTypes.BULLET) return BULLET_TOOLTIP_BASE;

    if (HeatmapConfig || XRangeConfig) {
        return config;
    }

    var ChartType = ChartConfig.ChartType;


    var chartType = ChartType.toLowerCase();
    var staticPosition = ['pie', 'doughnut'].includes(chartType);

    var positioner = staticPosition ? function () {
        return {
            x: this.chart.hoverPoint.tooltipPos[0],
            y: this.chart.hoverPoint.tooltipPos[1]
        };
    } : undefined;
    var animation = staticPosition ? false : true;

    config = _extends({}, config, {
        positioner: positioner,
        animation: animation
    }, cloneDeep(customConfig));

    return config;
};

export default configureTooltip;